<template>
  <div class="main">
    <div class="query-item">
      <div class="search-l">
        <div class="ml5">
          屏幕名称
          <a-input class="inp ml24" placeholder="请输入" v-model:value="query.screenName"></a-input>
        </div>

        <a-button class="ml30" @click="search" type="primary" ghost>查询</a-button>
        <a-button class="ml24" @click="reset" type="primary" ghost>重置</a-button>
      </div>
      <div class="search-r">
        <a-button type="primary" @click="handleAddScreen">
          <template #icon><PlusOutlined /></template>
          添加屏幕
        </a-button>
      </div>
    </div>

    <a-table :columns="columns" :row-key="(record) => record.id"
             size="middle" class="mt23" :scroll="{ y: 'auto' }"
             v-autoHeight="{ extraHeight: 88, trHeight: 47 }"
             :data-source="dataSource"
             :pagination="pagination">
      <template #bodyCell="{ column, record, index }">
        <template v-if="column.key === 'index'">
          {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
        </template>
        <template v-if="column.key === 'action'">
          <span>
            <a style="color: #52c41a" @click="handleOpenMonitor(record)">开启监控</a>
            <a class="ml10" @click="handleSetting(record)">设置</a>
            <a class="ml10" style="color: #ff4d4f" @click="handleDelete(record)">删除</a>
          </span>
        </template>
      </template>
    </a-table>
  </div>
</template>

<script setup>
import { ref, onMounted, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { PlusOutlined } from '@ant-design/icons-vue';
import { Modal, message } from 'ant-design-vue';
import { getScreenPageList, createScreen, deleteScreen } from '@/api/monitor/screen';

const router = useRouter();

const columns = [
  {
    title: "序号",
    key: "index",
    width: 80,
    align: "center"
  },
  {
    title: "屏幕名称",
    dataIndex: "name",
    key: "name",
    width: 400,
    align: "center"
  },
  {
    title: "规格",
    dataIndex: "spec",
    key: "spec",
    width: 120,
    align: "center"
  },
  {
    title: "备注",
    dataIndex: "remarks",
    key: "remarks",
    align: "center"
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    key: "createTime",
    width: 180,
    align: "center"
  },
  {
    title: "操作",
    key: "action",
    width: 250,
    align: "center"
  }
];

let dataSource = ref([]);

let query = reactive({
  screenName: ""
});

const pagination = reactive({
  total: 0,
  size: "middle",
  defaultPageSize: 10,
  current: 1,
  pageSize: 10,
  showSizeChanger: true,
  showQuickJumper: false,
  pageSizeOptions: ["10", "20", "30"],
  showTotal: (total) => `共有 ${total} 条数据`,
  onShowSizeChange: (current, pageSize) => (pagination.pageSize = pageSize),
  onChange: pageChange,
  showSizeChange: pageSizeChange,
});

function pageChange(page, pageSize) {
  pagination.current = page;
  getData();
}

function pageSizeChange(current, size) {
  pagination.pageSize = size;
  getData();
}

const search = () => {
  pagination.current = 1;
  getData();
};

const reset = () => {
  query.screenName = "";
  pagination.current = 1;
  getData();
};

const getData = () => {
  const data = {
    pageIndex: pagination.current,
    pageSize: pagination.pageSize,
    conditionMap: { ...query },
  };
  getScreenPageList(data).then((res) => {
    dataSource.value = res.data.records || [];
    pagination.total = res.data.total;
  });
};

// 添加屏幕
const handleAddScreen = () => {
  const screenCount = pagination.total + 1;
  createScreen({ name: `屏幕${screenCount}` }).then((res) => {
    if (res.code === 200) {
      message.success('添加成功');
      getData();
    }
  });
};

// 开启监控
const handleOpenMonitor = (screen) => {
  const url = router.resolve({
    path: '/test/monitor/screenmonitor',
    query: { id: screen.id }
  }).href;
  window.open(url, '_blank');
};

// 设置屏幕
const handleSetting = (screen) => {
  router.push({
    path: '/test/monitor/screensetting',
    query: { id: screen.id }
  });
};

// 删除屏幕
const handleDelete = (screen) => {
  Modal.confirm({
    title: '确认删除',
    content: `确定要删除"${screen.name}"吗？`,
    okText: '确认',
    cancelText: '取消',
    onOk: () => {
      deleteScreen(screen.id).then((res) => {
        if (res.code === 200) {
          message.success('删除成功');
          getData();
        }
      });
    }
  });
};

onMounted(() => {
  getData();
});
</script>

<style lang="less" scoped>
.inp {
  width: 13.5vw;
}

.query-item {
  display: flex;
  justify-content: space-between;

  .search-l {
    display: flex;
  }

  .search-r {
    display: flex;
  }
}

/deep/.ant-input::placeholder {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #68767E;
}

.main {
  padding: 20px;
  height: calc(100vh - 70px - 57px);
  background-color: #ffffff;
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th,
.ant-table-wrapper .ant-table-thead>tr>td {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(10, 33, 46, 1);
  background-color: rgba(239, 240, 245, 1);
}

/deep/.ant-table-wrapper .ant-table:not(.ant-table-bordered) .ant-table-tbody>tr {
  color: rgba(104, 118, 126, 1);
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before,
.ant-table-wrapper .ant-table-thead>tr>td:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
  width: 0px;
}

a {
  color: #1E8EF2;
  cursor: pointer;
}
</style>